import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { PesajeTrasladoApi } from "../../../api/PesajeTrasladoApi";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";

export const useFormPesaje = function (params) {
    const { trasladoDetalle, materiaPrimaSeleccionada, onAsignacionPesoSuccess } = params;

    const { asignarPesoMateriaPrima, cargando } = PesajeTrasladoApi();

    const {
        control,
        reset,
        trigger: validateForm,
        watch,
        getValues: formGetValues,
        formState: { errors },
        setValue: formSetValue,
    } = useForm({
        defaultValues: {
            acopio: null,
            piloto: null,
            vehiculo: null,
            peso_tara: "",
            peso_bruto: "",
        },
        mode: "onChange",
    });

    // Peso neto
    const pesoBruto = watch("peso_bruto");
    const pesoTara = watch("peso_tara");

    const pesoNeto = useMemo(
        function () {
            if (!pesoBruto || !pesoTara) return "";
            return parseFloat(pesoBruto) - parseFloat(pesoTara);
        },
        [pesoBruto, pesoTara],
    );

    // Submit
    const AsignarPesoMateriaPrima = async function () {
        const isValid = await validateForm();
        if (!isValid) return;

        const body = {
            traslado_id: trasladoDetalle.id,
            materia_prima_id: materiaPrimaSeleccionada.materia_prima.id,
            peso_final: pesoBruto,
        };

        try {
            await asignarPesoMateriaPrima(body);

            NotificationManager.success(
                "Peso asignado correctamente",
                "Éxito",
                3000,
            );

            onAsignacionPesoSuccess();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al asignar el peso a la materia prima.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    return {
        control,
        formSetValue,
        formGetValues,
        errors,

        pesoNeto,
        AsignarPesoMateriaPrima,
        cargando,
    };
};
